import { useCallback } from 'react';
import { useTenantLocale } from 'utils/hooks/useTenantConfig';

interface FormatterProps {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  locale?: string;
}

export function useNumberFormatter() {
  const userLocale = useTenantLocale();

  return useCallback(
    (
      value: number | string,
      { minimumFractionDigits = 0, maximumFractionDigits = 2, locale = userLocale }: FormatterProps = {}
    ) =>
      numberFormat(value, {
        minimumFractionDigits,
        maximumFractionDigits,
        locale
      }),
    [userLocale]
  );
}

export function numberFormat(
  value: number | string,
  { minimumFractionDigits = 0, maximumFractionDigits = 2, locale }: FormatterProps = {}
) {
  const targetValue = typeof value === 'string' ? parseFloat(value) : value;
  return new Intl.NumberFormat(locale, { minimumFractionDigits, maximumFractionDigits }).format(targetValue);
}

export const getNumberKFormat = (count: number) => {
  const formatter = Intl.NumberFormat('en', { notation: 'compact' });
  // display "K" notation for numbers >= 10,000 (e.g. 10K, 100K, 1M)
  return count >= 10000 ? formatter.format(count) : count;
};
